import { useEffect } from "react";
import { useI18n } from "@/lib/i18n";

// Lightweight document-title/meta updater per page (no helmet dep)
export default function SeoHead({ titleKey, descKey }) {
  const { t, lang } = useI18n();

  useEffect(() => {
    const title = t(titleKey);
    const desc = t(descKey);
    document.title = title;

    const ensure = (name, content, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let tag = document.querySelector(`meta[${attr}="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    ensure("description", desc);
    ensure("og:title", title, true);
    ensure("og:description", desc, true);
    ensure("og:type", "website", true);
    document.documentElement.lang = lang;
  }, [t, lang, titleKey, descKey]);

  return null;
}
